import React, { useState } from 'react';

import AppLoadingView from '../../../../mobile/components/AppLoadingView';
import { GroupChannel } from '@sendbird/chat/groupChannel';
import IntroScreen from '../../../../mobile/screens/IntroScreen';
import { SendbirdMessage } from '../../../../Types';
import WebModal from '../../app/components/WebModal';
import { setChannel } from '../../../../shared/redux/actions/ChatActions';
import { setViewReady } from '../../../../shared/redux/actions/SystemActions';
import { useDispatch } from 'react-redux';

export default function WebLoadingView(): JSX.Element {
  const [introVisible, setIntroVisible] = useState(false);

  const dispatch = useDispatch();

  const navToChatScreen = (
    channel: GroupChannel,
    message?: SendbirdMessage
  ) => {
    dispatch(setChannel(channel));
    dispatch(setViewReady(true));
  };

  const showIntroModal = () => {
    showModal();
  };

  const showModal = () => setIntroVisible(true);
  const closeModal = () => setIntroVisible(false);

  return (
    <>
      <AppLoadingView
        screenProps={{}}
        // @ts-ignore
        navToChatScreen={navToChatScreen}
        showIntroModal={showIntroModal}
      />
      <WebModal open={introVisible} onClose={closeModal}>
        {/* @ts-ignore */}
        <IntroScreen navigation={{ goBack: closeModal }} />
      </WebModal>
    </>
  );
}
